import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Link } from 'react-router'
import { compose } from 'redux'
import withSeparateAuthFlow from '../hoc/separate-auth-flow'
import withFacebookLogin from '../hoc/facebook-login'
import { publishTracking } from '../../services/tracking'
import MoreDetails from './more-details'
import Google from '../social/google/google'
import Facebook from '../social/facebook/facebook'
import Twitter from '../social/twitter/twitter'
import ErrorPopup from '../error-popup/error-popup'
import LoadingSvg from '../loading-svg'
import {
  LOGIN_PENDING,
  GOOGLE_LOGIN_PENDING,
  TWITTER_LOGIN_PENDING,
  CLEAR_GOOGLE_ERROR,
  CLEAR_TWITTER_ERROR,
  CLEAR_SIGN_IN_ERROR,
} from '../../actions'
import '../sign-up/sign-up.css'

class SignIn extends Component {
  state = {
    checkbox: true,
    error: false,
    email: '',
    password: '',
    uiPending: false,
  };

  responseTwitterLogin = (response) => {
    const { handleAction, redirectUri } = this.props

    handleAction(TWITTER_LOGIN_PENDING, {
      isRedirectFlow: !!redirectUri,
      ...response,
    })
  }

  responseGoogleLogin = (response) => {
    const { handleAction, redirectUri } = this.props

    handleAction(GOOGLE_LOGIN_PENDING, {
      isRedirectFlow: !!redirectUri,
      ...response,
    })
  }

  emailHandler = (e) => {
    this.setState({
      email: e.target.value,
    })
  }

  passwordHandler = (e) => {
    this.setState({
      password: e.target.value,
    })
  }

  checkboxHandler = (e) => {
    this.setState({ checkbox: e.target.checked })
  }

  LogIn = (e) => {
    e.preventDefault()

    const { handleAction, redirectUri } = this.props
    const { email, password, checkbox } = this.state

    this.setState({ uiPending: true })

    handleAction(LOGIN_PENDING, {
      email: email,
      password: password,
      rememberPassword: checkbox,
      isRedirectFlow: !!redirectUri,
    })
  }

  googleErrorHandler = () => {
    const { handleAction, googleError } = this.props

    if (googleError !== '') {
      setTimeout(() => handleAction(CLEAR_GOOGLE_ERROR), 30000)
      return googleError
    }
    return ''
  }

  twitterErrorHandler = () => {
    const { handleAction, twitterError } = this.props

    if (twitterError !== '') {
      setTimeout(() => handleAction(CLEAR_TWITTER_ERROR), 30000)
      return twitterError
    }
    return ''
  }

  signInErrorHandler = () => {
    const { handleAction, signInError } = this.props

    if (signInError !== '') {
      setTimeout(() => handleAction(CLEAR_SIGN_IN_ERROR), 30000)
      return signInError
    }
    return ''
  }

  alreadyRegisteredHandler = (options) => {
    const {
      facebookError = '',
      twitterError = '',
      googleError = '',
      signInError = '',
    } = options
    const filterError = [facebookError, twitterError, googleError, signInError].filter((value) => value.includes('You are already registered using'))

    if (!filterError.length) {
      return ''
    }

    // Regex used by type="email" from W3C - source https://emailregex.com/
    const emailRegex = new RegExp('[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)')
    const email = emailRegex.exec(filterError[0])

    if (!email) {
      return ''
    }

    const { t } = this.props

    return t('ERROR_ALREADY_REGISTERED', { email: email[0]})
  }

  forgotPasswordHandler = () => {
    const { redirectUri } = this.props

    if (!redirectUri) {
      publishTracking({
        userAction: 'forgot pass click',
        event: 'event148',
      })
    }
  }

  joinHereHandler = () => {
    const { redirectUri } = this.props

    if (!redirectUri) {
      publishTracking({
        userAction: 'drawer: sign up',
        event: 'event98',
      })
    }
  }

  render() {
    const {
      t,
      missingFields,
      clientId,
      provider,
      providerSecret,
      providerToken,
      handleAction,
      facebookLoginResponse,
      facebookErrorHandler,
    } = this.props
    const { uiPending, error, checkbox } = this.state
    const facebookError = facebookErrorHandler()
    const twitterError = this.twitterErrorHandler()
    const googleError = this.googleErrorHandler()
    const signInError = this.signInErrorHandler()
    const alreadyRegisteredError = this.alreadyRegisteredHandler({
      facebookError,
      twitterError,
      googleError,
      signInError,
    })

    const showLoadingSvg = uiPending && !signInError

    return (
      <div className="sign-up-page xs-flex xs-justify-center xs-items-center xs-fill-gray-lighter clearfix">

        {missingFields.length > 0
        && (
          <MoreDetails
            t={t}
            missingFields={missingFields}
            clientId={clientId}
            provider={provider}
            providerSecret={providerSecret}
            providerToken={providerToken}
            handleAction={handleAction}
            facebookError={facebookError}
            googleError={googleError}
            twitterError={twitterError}
          />
        )}

        {missingFields.length === 0
          && (
          <div className="auth-modal xs-py3 xs-px4 xs-col-12">

            <div className="modal-header__title xs-text-3 xs-px5 xs-text-center">{t('SIGN_IN_TITLE')}</div>
            <div className="modal-content xs-mt5">
              <div className="xs-overflow-hidden rounded">
                <Facebook buttonText={t('SIGN_IN_FB')} onLoginResponse={facebookLoginResponse} />
                <Twitter buttonText={t('SIGN_IN_TW')} onLoginResponse={this.responseTwitterLogin} />
                <Google buttonText={t('SIGN_IN_GG')} onLoginResponse={this.responseGoogleLogin} />
              </div>

              <form className="login-mail xs-relative xs-mt4" onSubmit={this.LogIn}>
                <div className="xs-text-center">
                  <span className="xs-absolute xs-mt2 xs-border xs-border-bottom-none xs-border-left-none xs-border-right-none xs-block xs-col-12" />
                  <span className="xs-text-gray xs-fill-gray-lighter xs-inline-block xs-px4 xs-relative xs-text-8">{t('SIGN_IN_EM')}</span>
                </div>

                <input
                  type="email"
                  className={`sign-with email xs-mt3 xs-py3 xs-fit text-input xs-border-bottom-none ${error && 'error-input'}`}
                  placeholder={t('YOUR_EMAIL')}
                  autoComplete="email"
                  onChange={this.emailHandler}
                  required
                  data-test-id="email"
                />
                <input
                  type="password"
                  className={`sign-with password xs-py3 xs-fit text-input ${error && 'error-input'}`}
                  placeholder={t('YOUR_PASSWORD')}
                  autoComplete="current-password"
                  onChange={this.passwordHandler}
                  required
                  data-test-id="password"
                />
                {error
                && <span className="error-text">{t('SIGN_IN_VALIDATION_ERROR')}</span>}
                <div className="sign-with chk-group xs-block">
                  <div className="xs-my4 xs-inline-block xs-text-gray">
                    <label htmlFor="remember">
                      <input
                        type="checkbox"
                        className="check"
                        onChange={this.checkboxHandler}
                        name="remember"
                        id="remember"
                        checked={checkbox}
                      />
                      <span>{t('REMEMBER')}</span>
                    </label>
                  </div>
                  <Link
                    className="forgot xs-border-none xs-inline-block xs-float-right xs-mt4 xs-text-red cursor-pointer"
                    to={"/forgotpwd" + this.props.location.search}
                    onClick={this.forgotPasswordHandler}
                  >
                    {t('FORGOT')}
                  </Link>
                </div>

                {alreadyRegisteredError
                && <ErrorPopup t={t} error={alreadyRegisteredError} />}

                {signInError
                && <ErrorPopup t={t} error={signInError} />}

                <button
                  className={`xs-fill-blue-cta rounded xs-border-none cond caps xs-text-white xs-py3 xs-col-12 ${showLoadingSvg && 'disabled'}`}
                  type="submit"
                  data-test-id="signin"
                >
                  {showLoadingSvg
                    ? <LoadingSvg />
                    : t('SIGN_IN_EM')}
                </button>
              </form>

            </div>

            <div className="modal-footer xs-text-7 xs-text-center">
              <div className="xs-mt5">
                {t('HAVE_ACCOUNT_YET')}
                <Link to="/signup" onClick={this.joinHereHandler} className="xs-text-red cursor-pointer">
                  {t('JOIN_HERE')}
                </Link>
              </div>
            </div>

          </div>
          )}
      </div>
    )
  }
}

SignIn.propTypes = {
  handleAction: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  googleError: PropTypes.string,
  twitterError: PropTypes.string,
  signInError: PropTypes.string,
  missingFields: PropTypes.arrayOf(PropTypes.string),
  clientId: PropTypes.string,
  provider: PropTypes.string,
  providerSecret: PropTypes.string,
  providerToken: PropTypes.string,
  facebookLoginResponse: PropTypes.func,
  facebookErrorHandler: PropTypes.func,
  redirectUri: PropTypes.string,
}

SignIn.defaultProps = {
  googleError: '',
  twitterError: '',
  signInError: '',
  missingFields: [],
  clientId: '',
  provider: '',
  providerSecret: '',
  providerToken: '',
  facebookLoginResponse: PropTypes.func,
  facebookErrorHandler: PropTypes.func,
  redirectUri: null,
}

export default compose(
  withSeparateAuthFlow,
  withFacebookLogin,
)(SignIn)



// WEBPACK FOOTER //
// ./src/components/sign-in/sign-in.js